import { api } from './api';

export type ChangeType = 'move' | 'merge' | 'split' | 'rename';

export interface DimensionMember {
  id: string;
  dimension_id: string;
  code: string;
  label: string;
  parent_id: string | null;
}
export interface DimensionWithMembers {
  id: string;
  workspace_id: string;
  key: string;
  label: string;
  members: DimensionMember[];
}

export interface OrgChangeMapping {
  id: string;
  from_member_id: string;
  to_member_id: string;
  from_code?: string;
  to_code?: string;
  from_label?: string;
  to_label?: string;
}
export interface OrgChange {
  id: string;
  workspace_id: string;
  dimension_id: string;
  dimension_key?: string;
  name: string;
  effective_from: string;
  change_type: ChangeType;
  description: string | null;
  created_at: string;
  updated_at: string;
  mappings: OrgChangeMapping[];
}

export interface OrgChangeInput {
  name: string;
  dimensionId: string;
  effectiveFrom: string;
  changeType: ChangeType;
  description?: string;
  mappings: { fromMemberId: string; toMemberId: string }[];
}

export const orgChangeApi = {
  list: async (wsId: string): Promise<OrgChange[]> => (await api.get(`/api/workspaces/${wsId}/org-changes`)).data,
  get: async (wsId: string, id: string): Promise<OrgChange> => (await api.get(`/api/workspaces/${wsId}/org-changes/${id}`)).data,
  create: async (wsId: string, body: OrgChangeInput): Promise<OrgChange> => (await api.post(`/api/workspaces/${wsId}/org-changes`, body)).data,
  update: async (wsId: string, id: string, body: Partial<OrgChangeInput>): Promise<OrgChange> => (await api.patch(`/api/workspaces/${wsId}/org-changes/${id}`, body)).data,
  remove: async (wsId: string, id: string): Promise<void> => { await api.delete(`/api/workspaces/${wsId}/org-changes/${id}`); },
};

export const dimensionsApi = {
  list: async (wsId: string): Promise<DimensionWithMembers[]> => (await api.get(`/api/workspaces/${wsId}/dimensions`)).data,
};
